/** Footer 四栏文案 — 18 语言 */
export const footerTranslations = {
  zh: {
    footerTagline: "工业打印解决方案供应商",
    footerReach: "服务172个国家客户",
    footerProductsTitle: "产品中心",
    footerProductUv: "UV打印机",
    footerProductUvDtf: "UV DTF打印机",
    footerProductCylinder: "圆柱体打印机",
    footerProductDtf: "DTF打印机",
    footerProductDtg: "DTG打印机",
    footerApplicationsTitle: "应用场景",
    footerAppPhoneCase: "手机壳",
    footerAppThermos: "保温杯",
    footerAppAcrylic: "亚克力",
    footerAppGlass: "玻璃",
    footerAppMetal: "金属",
    footerAppLuggage: "行李箱",
    footerContactTitle: "联系我们",
    footerWhatsapp: "WhatsApp",
    footerWhatsappTang: "唐先生：+86 17748697567",
    footerWhatsappSun: "孙先生：+86 15361896795",
    footerWhatsappSunDtfDtg: "孙先生：+86 17796314755",
    footerEmail: "Email",
    footerAddress: "华南公司地址",
    footerAddressValue:
      "中国广东省深圳市宝安区西乡街道易捷通新零售数字化产业园A座5层",
    footerAddressEast: "华东公司地址",
    footerAddressEastValue: "上海市松江区沪松公路1658号九润科技创新园区A栋",
    footerAddressVietnam: "越南公司地址",
    footerAddressVietnamValue:
      "102 Phạm Văn Sừng, Xuân Thới Thượng, Hóc Môn, Thành phố Hồ Chí Minh",
    footerEmailSales: "销售",
    footerEmailSupport: "技术支持",
    footerEmailExport: "海外业务",
    footerFactoryTour: "工厂参观",
    footerFactoryTourValue: "预约参观深圳生产基地",
    footerCatalogueDownload: "目录下载",
    footerCatalogueDownloadValue: "索取最新产品目录 PDF",
    footerCtaCatalogue: "获取产品目录",
    footerCtaFactory: "参观工厂",
    footerCtaDistributor: "成为经销商",
    footerSocialTitle: "扫码关注获取更多最新讯息",
    footerSocialFacebook: "Facebook",
    footerSocialYoutube: "YouTube",
    footerSocialXiaohongshu: "小红书",
    footerSocialDouyin: "抖音",
    footerSocialSaveHint: "长按二维码可保存图片",
    footerSocialSaveAria: "长按保存二维码",
  },
  en: {
    footerTagline: "Industrial Printing Solutions Provider",
    footerReach: "Serving customers in 172 countries",
    footerProductsTitle: "Products",
    footerProductUv: "UV Printers",
    footerProductUvDtf: "UV DTF Printers",
    footerProductCylinder: "Cylinder Printers",
    footerProductDtf: "DTF Printers",
    footerProductDtg: "DTG Printers",
    footerApplicationsTitle: "Applications",
    footerAppPhoneCase: "Phone Cases",
    footerAppThermos: "Thermos Cups",
    footerAppAcrylic: "Acrylic",
    footerAppGlass: "Glass",
    footerAppMetal: "Metal",
    footerAppLuggage: "Luggage",
    footerContactTitle: "Contact Us",
    footerWhatsapp: "WhatsApp",
    footerWhatsappTang: "唐先生：+86 17748697567",
    footerWhatsappSun: "孙先生：+86 15361896795",
    footerWhatsappSunDtfDtg: "孙先生：+86 17796314755",
    footerEmail: "Email",
    footerAddress: "South China Office Address",
    footerAddressValue:
      "5F, Building A, Ejetong New Retail Digital Industry Park, Xixiang Subdistrict, Bao'an District, Shenzhen, Guangdong, China",
    footerAddressEast: "East China Region Office Address",
    footerAddressEastValue:
      "Building A, Jiurun Technology Innovation Park, No. 1658 Husong Highway, Songjiang District, Shanghai, China",
    footerAddressVietnam: "Vietnam Office Address",
    footerAddressVietnamValue:
      "102 Pham Van Sung, Xuan Thoi Thuong, Hoc Mon, Ho Chi Minh City, Vietnam",
    footerEmailSales: "Sales",
    footerEmailSupport: "Support",
    footerEmailExport: "Export",
    footerFactoryTour: "Factory Tour",
    footerFactoryTourValue: "Book a visit to our Shenzhen facility",
    footerCatalogueDownload: "Catalogue Download",
    footerCatalogueDownloadValue: "Request the latest product catalogue",
    footerCtaCatalogue: "GET CATALOGUE",
    footerCtaFactory: "VISIT FACTORY",
    footerCtaDistributor: "BECOME DISTRIBUTOR",
    footerSocialTitle: "Scan to follow for the latest updates",
    footerSocialFacebook: "Facebook",
    footerSocialYoutube: "YouTube",
    footerSocialXiaohongshu: "Xiaohongshu",
    footerSocialDouyin: "Douyin",
    footerSocialSaveHint: "Long-press a QR code to save the image",
    footerSocialSaveAria: "Long-press to save QR code",
  },
  de: {
    footerTagline: "Anbieter industrieller Drucklösungen",
    footerReach: "Kunden in 172 Ländern",
    footerProductsTitle: "Produkte",
    footerProductUv: "UV-Drucker",
    footerProductUvDtf: "UV-DTF-Drucker",
    footerProductCylinder: "Zylinderdrucker",
    footerProductDtf: "DTF-Drucker",
    footerProductDtg: "DTG-Drucker",
    footerApplicationsTitle: "Anwendungen",
    footerAppPhoneCase: "Handyhüllen",
    footerAppThermos: "Thermosbecher",
    footerAppAcrylic: "Acryl",
    footerAppGlass: "Glas",
    footerAppMetal: "Metall",
    footerAppLuggage: "Gepäck",
    footerContactTitle: "Kontakt",
    footerWhatsapp: "WhatsApp",
    footerEmail: "E-Mail",
    footerAddress: "Niederlassung Ostchina",
    footerAddressValue:
      "5F, Gebäude A, Ejetong New Retail Digital Industry Park, Xixiang, Bezirk Bao'an, Shenzhen, Guangdong, China",
    footerCtaSolution: "Individuelle Lösung anfragen",
  },
  pt: {
    footerTagline: "Fornecedor de soluções de impressão industrial",
    footerReach: "Atendendo clientes em 172 países",
    footerProductsTitle: "Produtos",
    footerProductUv: "Impressoras UV",
    footerProductUvDtf: "Impressoras UV DTF",
    footerProductCylinder: "Impressoras cilíndricas",
    footerProductDtf: "Impressoras DTF",
    footerProductDtg: "Impressoras DTG",
    footerApplicationsTitle: "Aplicações",
    footerAppPhoneCase: "Capas de telefone",
    footerAppThermos: "Garrafas térmicas",
    footerAppAcrylic: "Acrílico",
    footerAppGlass: "Vidro",
    footerAppMetal: "Metal",
    footerAppLuggage: "Malas",
    footerContactTitle: "Contato",
    footerWhatsapp: "WhatsApp",
    footerEmail: "E-mail",
    footerAddress: "Filial Leste da China",
    footerAddressValue:
      "5F, Edifício A, Parque Industrial Digital Ejetong, Xixiang, Distrito Bao'an, Shenzhen, Guangdong, China",
    footerCtaSolution: "Obter solução personalizada",
  },
  es: {
    footerTagline: "Proveedor de soluciones de impresión industrial",
    footerReach: "Clientes en 172 países",
    footerProductsTitle: "Productos",
    footerProductUv: "Impresoras UV",
    footerProductUvDtf: "Impresoras UV DTF",
    footerProductCylinder: "Impresoras cilíndricas",
    footerProductDtf: "Impresoras DTF",
    footerProductDtg: "Impresoras DTG",
    footerApplicationsTitle: "Aplicaciones",
    footerAppPhoneCase: "Fundas de móvil",
    footerAppThermos: "Termos",
    footerAppAcrylic: "Acrílico",
    footerAppGlass: "Vidrio",
    footerAppMetal: "Metal",
    footerAppLuggage: "Equipaje",
    footerContactTitle: "Contáctenos",
    footerWhatsapp: "WhatsApp",
    footerEmail: "Correo",
    footerAddress: "Sucursal Este de China",
    footerAddressValue:
      "5.º piso, Edificio A, Parque Industrial Digital Ejetong, Xixiang, Distrito Bao'an, Shenzhen, Guangdong, China",
    footerCtaSolution: "Obtener solución personalizada",
  },
  fr: {
    footerTagline: "Fournisseur de solutions d'impression industrielle",
    footerReach: "Clients dans 172 pays",
    footerProductsTitle: "Produits",
    footerProductUv: "Imprimantes UV",
    footerProductUvDtf: "Imprimantes UV DTF",
    footerProductCylinder: "Imprimantes cylindriques",
    footerProductDtf: "Imprimantes DTF",
    footerProductDtg: "Imprimantes DTG",
    footerApplicationsTitle: "Applications",
    footerAppPhoneCase: "Coques de téléphone",
    footerAppThermos: "Thermos",
    footerAppAcrylic: "Acrylique",
    footerAppGlass: "Verre",
    footerAppMetal: "Métal",
    footerAppLuggage: "Bagages",
    footerContactTitle: "Contact",
    footerWhatsapp: "WhatsApp",
    footerEmail: "E-mail",
    footerAddress: "Agence Chine orientale",
    footerAddressValue:
      "5e étage, Bâtiment A, Parc industriel numérique Ejetong, Xixiang, district de Bao'an, Shenzhen, Guangdong, Chine",
    footerCtaSolution: "Obtenir une solution sur mesure",
  },
  it: {
    footerTagline: "Fornitore di soluzioni di stampa industriale",
    footerReach: "Clienti in 172 paesi",
    footerProductsTitle: "Prodotti",
    footerProductUv: "Stampanti UV",
    footerProductUvDtf: "Stampanti UV DTF",
    footerProductCylinder: "Stampanti cilindriche",
    footerProductDtf: "Stampanti DTF",
    footerProductDtg: "Stampanti DTG",
    footerApplicationsTitle: "Applicazioni",
    footerAppPhoneCase: "Cover per telefono",
    footerAppThermos: "Thermos",
    footerAppAcrylic: "Acrilico",
    footerAppGlass: "Vetro",
    footerAppMetal: "Metallo",
    footerAppLuggage: "Valigie",
    footerContactTitle: "Contatti",
    footerWhatsapp: "WhatsApp",
    footerWhatsappTang: "唐先生：+86 17748697567",
    footerWhatsappSun: "孙先生：+86 15361896795",
    footerWhatsappSunDtfDtg: "孙先生：+86 17796314755",
    footerEmail: "Email",
    footerAddress: "Filiale Cina orientale",
    footerAddressValue:
      "5° piano, Edificio A, Parco industriale digitale Ejetong, Xixiang, distretto di Bao'an, Shenzhen, Guangdong, Cina",
    footerCtaSolution: "Richiedi soluzione dedicata",
  },
  hi: {
    footerTagline: "औद्योगिक प्रिंटिंग समाधान प्रदाता",
    footerReach: "172 देशों में ग्राहक सेवा",
    footerProductsTitle: "उत्पाद",
    footerProductUv: "UV प्रिंटर",
    footerProductUvDtf: "UV DTF प्रिंटर",
    footerProductCylinder: "सिलिंडर प्रिंटर",
    footerProductDtf: "DTF प्रिंटर",
    footerProductDtg: "DTG प्रिंटर",
    footerApplicationsTitle: "अनुप्रयोग",
    footerAppPhoneCase: "फोन केस",
    footerAppThermos: "थर्मस",
    footerAppAcrylic: "एक्रिलिक",
    footerAppGlass: "कांच",
    footerAppMetal: "धातु",
    footerAppLuggage: "सामान",
    footerContactTitle: "संपर्क",
    footerWhatsapp: "WhatsApp",
    footerEmail: "ईमेल",
    footerAddress: "पूर्वी चीन शाखा पता",
    footerAddressValue:
      "5F, बिल्डिंग A, एजेटोंग न्यू रिटेल डिजिटल इंडस्ट्री पार्क, शिक्सियांग, बाओआन जिला, शेन्ज़ेन, गुआंगडोंग, चीन",
    footerCtaSolution: "विशेष समाधान प्राप्त करें",
  },
  ru: {
    footerTagline: "Поставщик промышленных печатных решений",
    footerReach: "Клиенты в 172 странах",
    footerProductsTitle: "Продукция",
    footerProductUv: "УФ-принтеры",
    footerProductUvDtf: "УФ DTF-принтеры",
    footerProductCylinder: "Цилиндрические принтеры",
    footerProductDtf: "DTF-принтеры",
    footerProductDtg: "DTG-принтеры",
    footerApplicationsTitle: "Применение",
    footerAppPhoneCase: "Чехлы для телефонов",
    footerAppThermos: "Термосы",
    footerAppAcrylic: "Акрил",
    footerAppGlass: "Стекло",
    footerAppMetal: "Металл",
    footerAppLuggage: "Чемоданы",
    footerContactTitle: "Контакты",
    footerWhatsapp: "WhatsApp",
    footerWhatsappTang: "唐先生：+86 17748697567",
    footerWhatsappSun: "孙先生：+86 15361896795",
    footerWhatsappSunDtfDtg: "孙先生：+86 17796314755",
    footerEmail: "Email",
    footerAddress: "Адрес восточного филиала",
    footerAddressValue:
      "5-й этаж, корпус A, цифровой индустриальный парк Ejetong, Сисян, район Баоань, Шэньчжэнь, провинция Гуандун, Китай",
    footerCtaSolution: "Получить индивидуальное решение",
  },
  ko: {
    footerTagline: "산업용 프린팅 솔루션 공급업체",
    footerReach: "172개국 고객 서비스",
    footerProductsTitle: "제품",
    footerProductUv: "UV 프린터",
    footerProductUvDtf: "UV DTF 프린터",
    footerProductCylinder: "원통형 프린터",
    footerProductDtf: "DTF 프린터",
    footerProductDtg: "DTG 프린터",
    footerApplicationsTitle: "응용 분야",
    footerAppPhoneCase: "휴대폰 케이스",
    footerAppThermos: "보온병",
    footerAppAcrylic: "아크릴",
    footerAppGlass: "유리",
    footerAppMetal: "금속",
    footerAppLuggage: "여행 가방",
    footerContactTitle: "문의하기",
    footerWhatsapp: "WhatsApp",
    footerEmail: "이메일",
    footerAddress: "화남 회사 주소",
    footerAddressValue:
      "중국 광둥성 선전시 바오안구 시향가도 이지통 신유통 디지털 산업원 A동 5층",
    footerAddressEast: "화동 지역 회사 주소",
    footerAddressEastValue:
      "상하이시 송장구 호송고속도로 1658호 구룬과학기술혁신단지 A동",
    footerAddressVietnam: "베트남 회사 주소",
    footerAddressVietnamValue:
      "102 Phạm Văn Sừng, Xuân Thới Thượng, Hóc Môn, Thành phố Hồ Chí Minh",
    footerCtaSolution: "맞춤 솔루션 받기",
  },
  ja: {
    footerTagline: "産業用プリンティングソリューション提供者",
    footerReach: "172カ国のお客様にサービス",
    footerProductsTitle: "製品",
    footerProductUv: "UVプリンター",
    footerProductUvDtf: "UV DTFプリンター",
    footerProductCylinder: "シリンダープリンター",
    footerProductDtf: "DTFプリンター",
    footerProductDtg: "DTGプリンター",
    footerApplicationsTitle: "応用シーン",
    footerAppPhoneCase: "スマホケース",
    footerAppThermos: "魔法瓶",
    footerAppAcrylic: "アクリル",
    footerAppGlass: "ガラス",
    footerAppMetal: "金属",
    footerAppLuggage: "スーツケース",
    footerContactTitle: "お問い合わせ",
    footerWhatsapp: "WhatsApp",
    footerEmail: "メール",
    footerAddress: "華南公司住所",
    footerAddressValue:
      "中国広東省深圳市宝安区西乡街道易捷通新零售数字化産業園A座5階",
    footerAddressEast: "華東地区会社住所",
    footerAddressEastValue:
      "上海市松江区沪松公路1658号九润科技创新园区A栋",
    footerAddressVietnam: "ベトナム会社住所",
    footerAddressVietnamValue:
      "102 Phạm Văn Sừng, Xuân Thới Thượng, Hóc Môn, Thành phố Hồ Chí Minh",
    footerCtaSolution: "専用ソリューションを取得",
  },
  th: {
    footerTagline: "ผู้ให้บริการโซลูชันการพิมพ์อุตสาหกรรม",
    footerReach: "ให้บริการลูกค้าใน 172 ประเทศ",
    footerProductsTitle: "ผลิตภัณฑ์",
    footerProductUv: "เครื่องพิมพ์ UV",
    footerProductUvDtf: "เครื่องพิมพ์ UV DTF",
    footerProductCylinder: "เครื่องพิมพ์ทรงกระบอก",
    footerProductDtf: "เครื่องพิมพ์ DTF",
    footerProductDtg: "เครื่องพิมพ์ DTG",
    footerApplicationsTitle: "การใช้งาน",
    footerAppPhoneCase: "เคสมือถือ",
    footerAppThermos: "กระติกน้ำ",
    footerAppAcrylic: "อะคริลิก",
    footerAppGlass: "แก้ว",
    footerAppMetal: "โลหะ",
    footerAppLuggage: "กระเป๋าเดินทาง",
    footerContactTitle: "ติดต่อเรา",
    footerWhatsapp: "WhatsApp",
    footerEmail: "อีเมล",
    footerAddress: "ที่อยู่สาขาจีนตะวันออก",
    footerAddressValue:
      "ชั้น 5 อาคาร A อุทยานอุตสาหกรรมดิจิทัล Ejetong เขตซีเซียง เขตเป่าอัน เซินเจิ้น กวางตุ้ง จีน",
    footerCtaSolution: "รับโซลูชันเฉพาะทาง",
  },
  tr: {
    footerTagline: "Endüstriyel baskı çözümleri sağlayıcısı",
    footerReach: "172 ülkede müşteri hizmeti",
    footerProductsTitle: "Ürünler",
    footerProductUv: "UV Yazıcılar",
    footerProductUvDtf: "UV DTF Yazıcılar",
    footerProductCylinder: "Silindir Yazıcılar",
    footerProductDtf: "DTF Yazıcılar",
    footerProductDtg: "DTG Yazıcılar",
    footerApplicationsTitle: "Uygulamalar",
    footerAppPhoneCase: "Telefon kılıfları",
    footerAppThermos: "Termoslar",
    footerAppAcrylic: "Akrilik",
    footerAppGlass: "Cam",
    footerAppMetal: "Metal",
    footerAppLuggage: "Bavullar",
    footerContactTitle: "İletişim",
    footerWhatsapp: "WhatsApp",
    footerEmail: "E-posta",
    footerAddress: "Doğu Çin Şubesi",
    footerAddressValue:
      "5. Kat, A Blok, Ejetong Yeni Perakende Dijital Endüstri Parkı, Xixiang, Bao'an, Shenzhen, Guangdong, Çin",
    footerCtaSolution: "Özel çözüm alın",
  },
  vi: {
    footerTagline: "Nhà cung cấp giải pháp in công nghiệp",
    footerReach: "Phục vụ khách hàng tại 172 quốc gia",
    footerProductsTitle: "Sản phẩm",
    footerProductUv: "Máy in UV",
    footerProductUvDtf: "Máy in UV DTF",
    footerProductCylinder: "Máy in hình trụ",
    footerProductDtf: "Máy in DTF",
    footerProductDtg: "Máy in DTG",
    footerApplicationsTitle: "Ứng dụng",
    footerAppPhoneCase: "Ốp điện thoại",
    footerAppThermos: "Bình giữ nhiệt",
    footerAppAcrylic: "Acrylic",
    footerAppGlass: "Thủy tinh",
    footerAppMetal: "Kim loại",
    footerAppLuggage: "Vali",
    footerContactTitle: "Liên hệ",
    footerWhatsapp: "WhatsApp",
    footerWhatsappTang: "唐先生：+86 17748697567",
    footerWhatsappSun: "孙先生：+86 15361896795",
    footerWhatsappSunDtfDtg: "孙先生：+86 17796314755",
    footerEmail: "Email",
    footerAddress: "Địa chỉ chi nhánh Hoa Đông",
    footerAddressValue:
      "Tầng 5, Tòa A, Khu công nghiệp số Ejetong, phường Xixiang, quận Bao'an, Thâm Quyến, Quảng Đông, Trung Quốc",
    footerCtaSolution: "Nhận giải pháp riêng",
  },
  nl: {
    footerTagline: "Leverancier van industriële printoplossingen",
    footerReach: "Klanten in 172 landen",
    footerProductsTitle: "Producten",
    footerProductUv: "UV-printers",
    footerProductUvDtf: "UV DTF-printers",
    footerProductCylinder: "Cilinderprinters",
    footerProductDtf: "DTF-printers",
    footerProductDtg: "DTG-printers",
    footerApplicationsTitle: "Toepassingen",
    footerAppPhoneCase: "Telefoonhoesjes",
    footerAppThermos: "Thermosflessen",
    footerAppAcrylic: "Acryl",
    footerAppGlass: "Glas",
    footerAppMetal: "Metaal",
    footerAppLuggage: "Bagage",
    footerContactTitle: "Contact",
    footerWhatsapp: "WhatsApp",
    footerEmail: "E-mail",
    footerAddress: "Vestiging Oost-China",
    footerAddressValue:
      "5e verdieping, Gebouw A, Ejetong New Retail Digital Industry Park, Xixiang, Bao'an, Shenzhen, Guangdong, China",
    footerCtaSolution: "Vraag een maatoplossing aan",
  },
  id: {
    footerTagline: "Penyedia solusi pencetakan industri",
    footerReach: "Melayani pelanggan di 172 negara",
    footerProductsTitle: "Produk",
    footerProductUv: "Printer UV",
    footerProductUvDtf: "Printer UV DTF",
    footerProductCylinder: "Printer silinder",
    footerProductDtf: "Printer DTF",
    footerProductDtg: "Printer DTG",
    footerApplicationsTitle: "Aplikasi",
    footerAppPhoneCase: "Casing ponsel",
    footerAppThermos: "Botol termos",
    footerAppAcrylic: "Akrilik",
    footerAppGlass: "Kaca",
    footerAppMetal: "Logam",
    footerAppLuggage: "Koper",
    footerContactTitle: "Hubungi Kami",
    footerWhatsapp: "WhatsApp",
    footerWhatsappTang: "唐先生：+86 17748697567",
    footerWhatsappSun: "孙先生：+86 15361896795",
    footerWhatsappSunDtfDtg: "孙先生：+86 17796314755",
    footerEmail: "Email",
    footerAddress: "Alamat Cabang China Timur",
    footerAddressValue:
      "Lantai 5, Gedung A, Taman Industri Digital Ejetong, Xixiang, Distrik Bao'an, Shenzhen, Guangdong, Tiongkok",
    footerCtaSolution: "Dapatkan solusi khusus",
  },
  ar: {
    footerTagline: "مزود حلول الطباعة الصناعية",
    footerReach: "خدمة العملاء في 172 دولة",
    footerProductsTitle: "المنتجات",
    footerProductUv: "طابعات UV",
    footerProductUvDtf: "طابعات UV DTF",
    footerProductCylinder: "طابعات أسطوانية",
    footerProductDtf: "طابعات DTF",
    footerProductDtg: "طابعات DTG",
    footerApplicationsTitle: "التطبيقات",
    footerAppPhoneCase: "أغطية الهواتف",
    footerAppThermos: "علب حرارية",
    footerAppAcrylic: "أكريليك",
    footerAppGlass: "زجاج",
    footerAppMetal: "معدن",
    footerAppLuggage: "حقائب سفر",
    footerContactTitle: "اتصل بنا",
    footerWhatsapp: "WhatsApp",
    footerEmail: "البريد الإلكتروني",
    footerAddress: "عنوان فرع شرق الصين",
    footerAddressValue:
      "الطابق الخامس، المبنى A، حديقة إيجيتونغ للصناعة الرقمية، شيشيانغ، منطقة باوآن، شنتشن، قوانغدونغ، الصين",
    footerCtaSolution: "احصل على حل مخصص",
  },
  pl: {
    footerTagline: "Dostawca rozwiązań druku przemysłowego",
    footerReach: "Obsługa klientów w 172 krajach",
    footerProductsTitle: "Produkty",
    footerProductUv: "Drukarki UV",
    footerProductUvDtf: "Drukarki UV DTF",
    footerProductCylinder: "Drukarki cylindryczne",
    footerProductDtf: "Drukarki DTF",
    footerProductDtg: "Drukarki DTG",
    footerApplicationsTitle: "Zastosowania",
    footerAppPhoneCase: "Etui na telefon",
    footerAppThermos: "Termosy",
    footerAppAcrylic: "Akryl",
    footerAppGlass: "Szkło",
    footerAppMetal: "Metal",
    footerAppLuggage: "Bagaż",
    footerContactTitle: "Kontakt",
    footerWhatsapp: "WhatsApp",
    footerEmail: "E-mail",
    footerAddress: "Adres oddziału wschodnich Chin",
    footerAddressValue:
      "5. piętro, Budynek A, Park Przemysłu Cyfrowego Ejetong, Xixiang, dzielnica Bao'an, Shenzhen, Guangdong, Chiny",
    footerCtaSolution: "Uzyskaj dedykowane rozwiązanie",
  },
};

const footerContactExtrasEn = {
  footerWhatsappTang: "唐先生：+86 17748697567",
  footerWhatsappSun: "孙先生：+86 15361896795",
  footerWhatsappSunDtfDtg: "孙先生：+86 17796314755",
  footerEmailSales: "Sales",
  footerEmailSupport: "Support",
  footerEmailExport: "Export",
  footerFactoryTour: "Factory Tour",
  footerFactoryTourValue: "Book a visit to our Shenzhen facility",
  footerCatalogueDownload: "Catalogue Download",
  footerCatalogueDownloadValue: "Request the latest product catalogue",
  footerCtaCatalogue: "GET CATALOGUE",
  footerCtaFactory: "VISIT FACTORY",
  footerCtaDistributor: "BECOME DISTRIBUTOR",
  footerSocialTitle: "Scan to follow for the latest updates",
  footerSocialFacebook: "Facebook",
  footerSocialYoutube: "YouTube",
  footerSocialXiaohongshu: "Xiaohongshu",
  footerSocialDouyin: "Douyin",
  footerSocialSaveHint: "Long-press a QR code to save the image",
  footerSocialSaveAria: "Long-press to save QR code",
  footerAddress: "South China Office Address",
  footerAddressEast: "East China Region Office Address",
  footerAddressEastValue:
    "Building A, Jiurun Technology Innovation Park, No. 1658 Husong Highway, Songjiang District, Shanghai, China",
  footerAddressVietnam: "Vietnam Office Address",
  footerAddressVietnamValue:
    "102 Pham Van Sung, Xuan Thoi Thuong, Hoc Mon, Ho Chi Minh City, Vietnam",
};

[
  "de",
  "pt",
  "es",
  "fr",
  "it",
  "hi",
  "ru",
  "ko",
  "ja",
  "th",
  "tr",
  "vi",
  "nl",
  "id",
  "ar",
  "pl",
].forEach((code) => {
  footerTranslations[code] = {
    ...footerTranslations[code],
    ...footerContactExtrasEn,
  };
});

footerTranslations.vi = {
  ...footerTranslations.vi,
  footerAddressVietnam: "Địa chỉ công ty Việt Nam",
  footerAddressVietnamValue:
    "102 Phạm Văn Sừng, Xuân Thới Thượng, Hóc Môn, Thành phố Hồ Chí Minh",
};
